interface ApiErrorShape {
  response?: {
    data?: {
      message?: string;
    };
  };
  message?: string;
}

export const getApiErrorMessage = (
  error: unknown,
  fallback: string
): string => {
  if (!error || typeof error !== "object") return fallback;
  const { response, message } = error as ApiErrorShape;
  return response?.data?.message || message || fallback;
};
